'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
require('../browser-05a2bba8.js');
require('../_commonjsHelpers-3fc1f64e.js');
require('../_react_commonjs-external-30e5c7b3.js');
var index = require('../index-db6682ea.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-around;\n"], ["\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-around;\n"]);

var StyledTwoSideList = styled__default.div(_templateObject);

var TwoSideList = function TwoSideList(_ref) {
  var children = _ref.children;
  return React__default.createElement(
    StyledTwoSideList,
    null,
    " ",
    children,
    " "
  );
};

var TermList = function TermList(_ref2) {
  var lists = _ref2.lists;
  return React__default.createElement(
    TwoSideList,
    null,
    index.renderHTML(lists.list)
  );
};
TwoSideList.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TwoSideList"
};
TermList.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TermList"
};

exports.StyledTwoSideList = StyledTwoSideList;
exports.TwoSideList = TwoSideList;
exports.default = TermList;
//# sourceMappingURL=list.js.map
